if (!customElements.get('product-technologies-point-v2-item')) {
  class ProductTechnologiesPointItem extends HTMLElement {
    maxElapsedTime = 500;

    constructor() {
      super();
      this.section = this.closest('product-technologies-point-v2');
      this.summary = this.querySelector('.summary');
      this.content = this.querySelector('section');
      this.contentInner = this.content.firstElementChild;
      this.initEvent();
    }

    // 开启
    open() {
      for (const element of this.section.querySelectorAll('product-technologies-point-v2-item[open]')) {
        if (element.hasAttribute('open')) {
          element.close();
        }
      }
      this.content.style.height = this.contentInner.clientHeight + 'px';
      this.setAttribute('open', '');
    }

    // 关闭
    close() {
      this.content.style.height = '0px';
      this.removeAttribute('open');
    }

    initEvent() {
      this.summary.addEventListener('click', () => {
        if (this.hasAttribute('open')) {
          this.close();
        } else {
          this.open();
        }
      });
      document.addEventListener('click', (e) => {
        if (!e.target.closest('product-technologies-point-v2-item')) {
          this.close();
        }
      });
    }
  }
  customElements.define('product-technologies-point-v2-item', ProductTechnologiesPointItem);
}